module.exports = __webpack_public_path__ + "img/across chest.b33274f4.png";